require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./sheshines-28-nov-2024.json") })
        }
      }, "path---sheshines-28-nov-2024");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---sheshines-28-nov-2024!./.cache/json/sheshines-28-nov-2024.json
// module id = 1204
// module chunks = 231608221292675